/**
 * 「同じロールカードを再クリック」で `role_name_*` ↔ `credit_title_*` を切り替える
 * 表示パターン用の、表示すべき名前文字列を解決する共通ヘルパ。
 *
 * 既定（`useCreditTitle=false`）は `defaultName`（`role_name_*`）を、
 * 再クリック後（`useCreditTitle=true`）は `creditName`（`credit_title_*`）を優先する。
 * 選んだ側が空文字 / undefined のときはもう一方にフォールバック。両方空 / undefined の
 * ときは `null` を返し、呼び出し側でラベル自体を非表示にする想定。
 *
 * arc モードでカード右辺の縦書きラベル（英語）と、副パネルプレビューの日本語 / 英語名で
 * 共通利用する。
 */
export const pickRoleDisplayName = (
  defaultName: string | undefined,
  creditName: string | undefined,
  useCreditTitle: boolean,
): string | null => {
  const primary = useCreditTitle ? creditName : defaultName;
  const fallback = useCreditTitle ? defaultName : creditName;
  return primary?.trim() || fallback?.trim() || null;
};
